<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col equal-height :span="6" md8 sm12 xs24 v-for="(gauge, index) in gauges" :key="index">
        <card full-height align="center">
          <card-text>
            <gauge @input="onInput" v-model="gauge.value" :label-size="labelSize" :label-color="gauge.progressColor" :label="label" :rounded="rounded" :size="size" :width="width" :track-color="$dark ? '#000' : '#eee'" :progress-color="gauge.progressColor" />
          </card-text>
          <divider />
          <card-actions align="left">
            <table-layout y-align="middle">
              <row>
                <cell x-align="left">
                  <color-picker :tile="false" icon="format-color-fill" v-model="gauge.progressColor" />
                </cell>
                <cell x-align="right">
                  <btn :class="['mr-2']" :title="$lang.decrease" icon="minus-circle" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :disabled="gauge.value === 0" @click="repaint(index, false)">-</btn><!--
                  --><btn :title="$lang.increase" icon="plus-circle" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :disabled="gauge.value === 100" @click="repaint(index)">+</btn>
                </cell>
              </row>
            </table-layout>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageGauge',
  mixins: [
    methods
  ],
  data () {
    return {
      gauges: [],
      width: 2.5,
      radius: 64,
      size: 200,
      rounded: true,
      label: true,
      labelSize: '2xl'
    }
  },
  mounted () {
    this.getExternalData('gauge.json', 'gauges')
  },
  methods: {
    repaint (index, increase = true, step = 5) {
      const value = this.gauges[index].value
      this.gauges[index].value = increase ? value + step : value - step
    },
    onInput ($event) {
      this.log('input', 'gauge', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/gauge.vue